import Box from '@mui/material/Box';
import PropTypes from 'prop-types';
import React from 'react';
import Card from './components/Card';
import utils from 'util/utils';
import AlertDialog from './components/AlertDialog';
import { withRouter } from '../withRouter';
import { ArrowLeft, ArrowRight } from 'assets/images';
import { connect } from 'react-redux';
import { appNavigate, leaveConference } from 'store/modules/app/actions';
import html2canvas from 'html2canvas';

class Home extends React.Component {
  // const ref = useRef(null);
  constructor(props) {
    super(props);
    this.ref = React.createRef(null);
    this.state = {
      endSession: true,
      homeGroup: null,
      joinAlert: false
    };
    this.join = this.join.bind(this);
    this.joinConference = this.joinConference.bind(this);
  }
  componentDidMount() {
    this._mounted = true;
    const { _user, _room } = this.props;
    if (_user) {
      _user.device?.groups?.forEach((item) => {
        if (item.home) {
          this.setState({
            homeGroup: typeof item._id === 'string' ? item : item._id
          });
        }
      });
    }
    // const params = new Map(location.search.slice(1).split('&').map(kv => kv.split('=')))
    const location = this.props.router?.location;
    if (
      location?.state &&
      location.state.room &&
      location.state.room !== _room
    ) {
      // eslint-disable-next-line react/no-did-mount-set-state
      this.setState({ room: location.state.room }, () => {
        this.join(location.state?.groupChange ? true : false);
      });
    }

    if (this.props.snapshot) {
      try {
        html2canvas(document.body).then((canvas) => {
          try {
            const base64Image = canvas.toDataURL('image/png');

            this.setState({ snapshot: base64Image });
          } catch (err) {
            console.error(err);
          }
        });
      } catch (err) {
        console.error(err);
      }
    }
  }

  /**
   * Implements React's {@link Component#componentWillUnmount()}. Invoked
   * immediately before this component is unmounted and destroyed.
   *
   * @inheritdoc
   */
  componentWillUnmount() {
    this._mounted = false;
  }

  handleJoin(group) {
    if (this.props._room && this.state.endSession) {
      window.joinNewRoom = group._id;
      this.props.dispatch(
        leaveConference('/groups', { room: group._id, groupChange: true })
      );
    } else {
      this.setState({ room: group._id }, () => {
        this.join();
        if (this.props.onClose) this.props.onClose();
      });
    }
  }

  // TODO: Review when re-implementing single device login enforcement
  // For now will always proceed to joinConference
  join(isGroupChange = false) {
    const { _user } = this.props;
    // TODO add remote device condition
    if (
      utils.isRemoteLogin(_user) &&
      utils.isConferenceLive(_user.device.status)
    ) {
      this.setState({
        joinAlert: true
      });
      return;
    }
    this.joinConference(isGroupChange);
  }

  joinConference(isGroupChange = false) {
    let room = this.state.room;
    const { _user } = this.props;
    const name = utils.getUsername(_user);

    room = `${room}#userInfo.displayName="${name}"`;
    if (utils.isRemoteLogin(_user)) {
      room = `${room}&config.startWithVideoMuted=true`;
    } else {
      room = `${room}&config.startWithVideoMuted=false`;
    }
    if (_user?.device?.options?.showJoinLeaveAudioButton === 0) {
      room = `${room}&config.videoOnly=${
        _user?.device?.options?.speakerMode === 0
      }`;
    }
    if (_user?.device?.options?.showMicrophoneButton === 0) {
      room = `${room}&config.startWithAudioMuted=${
        _user?.device?.options?.microphoneMode === 0
      }`;
    } else {
      room = `${room}&config.startWithAudioMuted=true`;
    }
    window.meetingUrl = room;
    if (room) {
      this.setState({ joining: true });

      // By the time the Promise of appNavigate settles, this component
      // may have already been unmounted.
      const onAppNavigateSettled = () =>
        this._mounted && this.setState({ joining: false });
      this.props
        .dispatch(appNavigate(room, isGroupChange))
        .then(onAppNavigateSettled, onAppNavigateSettled);
    }
  }

  render() {
    const { _user } = this.props;
    const groups = _user.device?.groups ?? [];
    const isRemote = utils.isRemoteLogin(_user);
    return (
      <Box className="homeContainer">
        <Box className="relativeView">
          <Box className="headingText">Home Group</Box>
          <Box className="flexBox">
            {this.state.homeGroup && (
              <Card
                key={-1}
                group={this.state.homeGroup}
                home={true}
                onEnd={() => {
                  this.setState({ endSession: false });
                  this.props.onLeave();
                }}
                onJoin={() => this.handleJoin(this.state.homeGroup)}
                onReturn={() => this.props.onClose()}
                room={this.props._room}
                user={this.props._user}
              />
            )}
            {/* <Box className="cardContainer">
                <Box className="flexIcon">
                  <HomeIcon
                    height={20}
                    width={20}
                    style={{
                      marginRight: '16px',
                      borderRadius: '24px',
                      boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.15)'
                    }}
                  />
                  <Box className="bodyText">{this.state.homeGroup?.name}</Box>
                </Box>
                {this.props._room === this.state.homeGroup?._id ? (
                  <Box className="groupView">
                    <Link style={{ textDecoration: 'none' }}>
                      <GroupButton onClick={this.props.onClose} yellow={true}>
                        Return Now
                      </GroupButton>
                    </Link>
                    {this.props._user.device?.type !== 'device' && (
                      <GroupButton
                        onClick={() => {
                          this.setState({ endSession: false });
                          this.props.onLeave();
                        }}
                        red={true}>
                        end session
                      </GroupButton>
                    )}
                  </Box>
                ) : (
                  <Box className="groupView">
                    <Link
                      style={{
                        textDecoration: 'none',
                        margin: 'auto'
                      }}>
                      <GroupButton
                        green={true}
                        onClick={() =>
                          this.handleJoin({ ...this.state.homeGroup })
                        }>
                        Join Now
                      </GroupButton>
                    </Link>
                  </Box>
                )}
              </Box> */}
            {this.props._room && (
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  '@media(minWidth: 800px)': {
                    position: 'relative',
                    margin: '16px'
                  }
                }}>
                {this.state.endSession === true && (
                  <Box className="conferenceView" onClick={this.props.onClose}>
                    {this.props.snapshot && <img src={this.state.snapshot} />}
                  </Box>
                )}
              </Box>
            )}
          </Box>
          <Box className="spaceBetween">
            <Box className="flexIcon">
              <Box className="headingText">Member Groups</Box>
            </Box>
            <Box className="flexIcon">
              <Box
                className="circle"
                onClick={() => scroll(-20)}
                sx={{ marginRight: '6px' }}>
                <ArrowLeft height={20} width={20} />
              </Box>
              <Box className="circle" onClick={() => scroll(20)}>
                <ArrowRight height={20} width={20} />
              </Box>
            </Box>
          </Box>
          <Box className="scrollView" ref={this.ref}>
            {groups?.map((stock, index) => (
              <Card
                key={index}
                group={typeof stock._id === 'string' ? stock : stock._id}
                onEnd={() => {
                  this.setState({ endSession: false });
                  this.props.onLeave();
                }}
                onJoin={() =>
                  this.handleJoin(
                    typeof stock._id == 'string' ? stock : stock._id
                  )
                }
                onReturn={() => this.props.onClose()}
                room={this.props._room}
                user={this.props._user}
              />
            ))}
          </Box>
        </Box>
        <AlertDialog
          open={this.state.joinAlert}
          handleClose={() => this.setState({ joinAlert: false })}
          onYes={() => {
            this.setState({ joinAlert: false });
            this.joinConference();
          }}
          title={
            isRemote
              ? 'notify.mulipleRemoteLoginTitle'
              : 'notify.mulipleOfficeLoginTitle'
          }
          description={
            isRemote
              ? 'notify.mulipleRemoteLoginMessage'
              : 'notify.mulipleOfficeLoginMessage'
          }
        />
      </Box>
    );
  }
}

Home.propTypes = {
  _user: PropTypes.object,
  _room: PropTypes.any,
  router: PropTypes.object,
  snapshot: PropTypes.any,
  dispatch: PropTypes.func,
  onClose: PropTypes.func,
  onLeave: PropTypes.func
};
/**
 * Maps part of the Redux state to the props of this component.
 *
 * @param {Object} state - The Redux state.
 * @returns {Object}
 */
function _mapStateToProps(state) {
  return {
    _room: state['features/base/conference'].room
  };
}

export default React.memo(withRouter(connect(_mapStateToProps)(Home)));
